module.exports = __webpack_public_path__ + "static/media/logo_for.1197c216.svg";